import { useEffect } from "react";

const DEFAULT_SITE_NAME = "Lapstr";
const DEFAULT_BASE_URL = "https://www.lapstr.se";
const DEFAULT_DESCRIPTION =
  "Lapstr ger dig digitala matchprotokoll för Bauhausligan i Speedway, samtidigt som du följer matcher, laguppställningar och tabell på ett ställe.";
const DEFAULT_IMAGE = "/icons/icon-512x512.png";

function upsertMeta(selector, attributes) {
  let element = document.head.querySelector(selector);
  if (!element) {
    element = document.createElement("meta");
    document.head.appendChild(element);
  }
  Object.entries(attributes).forEach(([key, value]) => {
    if (value == null) return;
    element.setAttribute(key, value);
  });
}

function upsertLink(selector, attributes) {
  let element = document.head.querySelector(selector);
  if (!element) {
    element = document.createElement("link");
    document.head.appendChild(element);
  }
  Object.entries(attributes).forEach(([key, value]) => {
    if (value == null) return;
    element.setAttribute(key, value);
  });
}

function toAbsoluteUrl(baseUrl, value) {
  try {
    return new URL(value, baseUrl).toString();
  } catch {
    return value;
  }
}

export default function Seo({
  title,
  description = DEFAULT_DESCRIPTION,
  canonicalPath = "/",
  image = DEFAULT_IMAGE,
  noindex = false,
  siteName = DEFAULT_SITE_NAME,
}) {
  useEffect(() => {
    const baseUrl = (process.env.REACT_APP_SITE_URL || DEFAULT_BASE_URL).replace(/\/+$/, "");
    const canonicalUrl = toAbsoluteUrl(baseUrl, canonicalPath);
    const imageUrl = toAbsoluteUrl(baseUrl, image);
    const fullTitle = title?.includes(siteName) ? title : `${title} | ${siteName}`;

    document.title = fullTitle;
    upsertMeta('meta[name="description"]', { name: "description", content: description });
    upsertMeta('meta[property="og:title"]', { property: "og:title", content: fullTitle });
    upsertMeta('meta[property="og:description"]', {
      property: "og:description",
      content: description,
    });
    upsertMeta('meta[property="og:type"]', { property: "og:type", content: "website" });
    upsertMeta('meta[property="og:url"]', { property: "og:url", content: canonicalUrl });
    upsertMeta('meta[property="og:site_name"]', { property: "og:site_name", content: siteName });
    upsertMeta('meta[property="og:image"]', { property: "og:image", content: imageUrl });
    upsertMeta('meta[name="twitter:card"]', { name: "twitter:card", content: "summary_large_image" });
    upsertMeta('meta[name="twitter:title"]', { name: "twitter:title", content: fullTitle });
    upsertMeta('meta[name="twitter:description"]', {
      name: "twitter:description",
      content: description,
    });
    upsertMeta('meta[name="twitter:image"]', { name: "twitter:image", content: imageUrl });
    upsertMeta('meta[name="robots"]', {
      name: "robots",
      content: noindex ? "noindex,nofollow" : "index,follow",
    });
    upsertLink('link[rel="canonical"]', { rel: "canonical", href: canonicalUrl });
  }, [canonicalPath, description, image, noindex, siteName, title]);

  return null;
}
